import './bml-footer.scss';
const TEMPLATE = `
<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <img class="footer-logo" src="/images/logo-header.svg?v=2" alt="BML Logo">
            </div>
            <div class="col-lg-6 col-md-6 footer-menu">
                <div class="column d-none d-md-block">
                    <h6>Навігація</h6>
                    <ul>
                        <li><a href="/about-us">Про нас</a></li>
                        <li><a href="/doslidzhennya">Дослідження</a></li>
                        <li><a href="/cases">Діагностичні кейси</a></li>
                        <li><a href="/about-work">Як це працює</a></li>
                        <li><a href="/#benefits">Партнерство</a></li>
                        <li><a href="/certificates">Сертифікати</a></li>
                        <li><a href="/vacancies">Кар'єра</a></li>
                        <li><a href="/news-feed">Новини</a></li>
                        <li><a href="/contacts">Контакти</a></li>
                    </ul>
                </div>

                <div class="column">
                    <h6 class="d-none d-md-block">Контакти</h6>
                    <div class="footer-city">
                        <p class="footer-city-name">Київ</p>
                        <ul>
                            <li><a href="tel:+380443334308">+38 044 333 43 08</a></li>
                            <li><a href="https://maps.google.com/?q=26/4-%D0%91+%D0%91%D1%83%D0%BB%D1%8C%D0%B2%D0%B0%D1%80+%D0%A2%D0%B0%D1%80%D0%B0%D1%81%D0%B0+%D0%A8%D0%B5%D0%B2%D1%87%D0%B5%D0%BD%D0%BA%D0%B0,%D0%9A%D0%B8%D1%97%D0%B2"
                                   target="_blank">бул. Т.Шевченка, 26/4-Б</a></li>
                        </ul>
                    </div>

                    <div class="footer-city">
                        <p class="footer-city-name">Львів</p>
                        <ul>
                            <li><a href="tel:+380443334308">+38 044 333 43 08</a></li>
                            <li><a href="https://maps.google.com/?q=%D0%92%D1%83%D0%BB.+%D0%A1%D1%82%D1%80%D0%B8%D0%B9%D1%81%D1%8C%D0%BA%D0%B0,+33,%D0%9B%D1%8C%D0%B2%D1%96%D0%B2"
                                   target="_blank">вул.Стрийська, 33</a></li>
                        </ul>
                    </div>
                </div>

                <div class="column">
                    <h6 class="d-none d-md-block">Графік роботи</h6>
                    <ul>
                        <li class="work-time">Пн-Сб 9:00 – 19:00</li>
                    </ul>
                </div>

                <div class="column d-none d-md-block" style="display: none !important;">
                    <h6>Соціальні Мережі</h6>
                    <ul>
                        <li><a href="https://instagram.com/yourcompany" target="_blank">Instagram</a></li>
                        <li><a href="https://www.facebook.com/p/Bogomolets-Medical-Laboratories-100078677265298/" target="_blank">Facebook</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="footer-bottom">
            <div class="footer-bottom__policies">
                <a class="footer-privacy-details" href="/privacy-policy">Політика конфіденційності</a>
                <a class="footer-privacy-details" href="/personal-data-policy">Політика обробки персональних даних</a>
                <a class="footer-privacy-details" href="/public-offer">Публічний договір (оферта)</a>
            </div>
            <img class="footer-title d-md-none" src="/images/Footer%20Text%20Mobile.svg" alt="">
            <img class="footer-title-image d-none d-md-block" src="/images/Footer-Title.svg" alt="">
        </div>
    </div>
</footer>
`;

class BmlFooter extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
    }
}

customElements.define('bml-footer', BmlFooter);
